import axios from 'axios'
import dssAPI from '@/utilities/dssAPI.js'

//dss api - get parks data from CMS
// 501 park site
// api = '//itdwigxcms501/qaSeattle/api/content/x64198/elements/Navigation/'
// old park site
// api = '//wwwqa.seattle.gov/api/content/x64198/elements/Navigation/'
// new park site
// api = '//wwwqa.seattle.gov/api/content/x141773/elements/Navigation/'
//api = '//wwwqa.seattle.gov/api/content/x162423/elements/Navigation/'
let api = dssAPI.path + '/content/x162423/elements/Navigation/'

let apiBackup = '/assets/prebuilt/vue/park-list/cmsParkListJson2.json'
//apiBackup = '/assets/prebuilt/vue/park-list/cmsParkListJson.json'
//api= '//itdwigxcms501/qaSeattle/api/content/x64198/elements/Navigation/'
let map = new Map();
//access dssapi
//https://seattle.gov/api/content/x64198/elements/Navigation/
////seattle.gov/api/content/x64198/elements/Navigation/
//element[0].children[1-6]

const getData = async () => {
  try {
    const { data } = await axios.get('https://services.arcgis.com/ZOyb2t4B0UYuYNYH/arcgis/rest/services/Park_Features_PT_VW/FeatureServer/0/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&outFields=*&maxRecordCountFactor=4&outSR=102100&resultOffset=0&resultRecordCount=8000&cacheHint=true&quantizationParameters=%7B%22mode%22%3A%22view%22%2C%22originPosition%22%3A%22upperLeft%22%2C%22tolerance%22%3A1.0583354500042494%2C%22extent%22%3A%7B%22xmin%22%3A1249620.0046131462%2C%22ymin%22%3A185536.20320013163%2C%22xmax%22%3A1291100.9337902218%2C%22ymax%22%3A271131.9617982954%2C%22spatialReference%22%3A%7B%22wkid%22%3A2926%2C%22latestWkid%22%3A2926%7D%7D%7D')
    delete data.features[0].attributes.OBJECTID
    delete data.features[0].attributes.created_user
    delete data.features[0].attributes.created_date
    delete data.features[0].attributes.last_edited_user
    delete data.features[0].attributes.last_edited_date
    delete data.features[0].attributes.GlobalID
    
    return data.features
  } catch (err) {
    console.log('Park list api failed')
    return []
  }
}

const getParklist = async ()=> {

  //create a map of parks pma and parks description
  const rawMenu = await getParkDescription()
  //get the javascript object
  let menus = rawMenu.elements
  //console.log('result of getparkdescription: ', menus) 
  //console.log(menus[0].children) 

  // Map created
  // var map = new Map();
  for (let x = 1; x < menus[0].children.length; x++){
    //console.log(x)
    for (let i of menus[0].children[x].children) {
      //insert key value in map
      map.set(i.attributes.pma, i.attributes.excerpt);  
    }
  }

  //create a list of parks
  let parks = await getData()    
  var clean = parks.filter((parks, index, self) =>
      index === self.findIndex((t) => (t.attributes.PMA === parks.attributes.PMA)))
      // remove the following PMA's from the list
  var filtered = clean.filter(function(item) {
    return item.attributes.PMA !== 234 
    && item.attributes.PMA !== 257
    && item.attributes.PMA !== 264
    && item.attributes.PMA !== 265
    && item.attributes.PMA !== 267
    && item.attributes.PMA !== 279
    && item.attributes.PMA !== 282
    && item.attributes.PMA !== 283
    && item.attributes.PMA !== 284
    && item.attributes.PMA !== 301
    && item.attributes.PMA !== 335
    && item.attributes.PMA !== 337
    && item.attributes.PMA !== 356
    && item.attributes.PMA !== 430
    && item.attributes.PMA !== 434
    && item.attributes.PMA !== 442
    && item.attributes.PMA !== 443
    && item.attributes.PMA !== 451
    && item.attributes.PMA !== 454
    && item.attributes.PMA !== 466
    && item.attributes.PMA !== 484
    && item.attributes.PMA !== 492
    && item.attributes.PMA !== 494
    && item.attributes.PMA !== 2848
    && item.attributes.PMA !== 3925
    && item.attributes.PMA !== 3996
    && item.attributes.PMA !== 4046
    && item.attributes.PMA !== 4401
    && item.attributes.PMA !== 4407
    && item.attributes.PMA !== 4409
    && item.attributes.PMA !== 4425
    && item.attributes.PMA !== 4609

    && item.attributes.PMA !== 623
    && item.attributes.PMA !== 4410
    && item.attributes.PMA !== 3115
    && item.attributes.PMA !== 313
    && item.attributes.PMA !== 4429
    && item.attributes.PMA !== 4617
    && item.attributes.PMA !== 271
    && item.attributes.PMA !== 4572
    && item.attributes.PMA !== 4104
    && item.attributes.PMA !== 3751

  });
     
  parks = filtered;
  
  // // //test map pma and desc
  //  for (var key of map.keys()) {
  //    console.log("looping through map " + key)
  //    //var descxx = map.get(key)
  //    //console.log("descxx " + descxx)
  //   console.log("this key " + key + " => " + map.get(key) + "</br>")
  //  }

  // Add Departments description
  for (let park of parks) {    
    //for hardcoded lookup table  
    //const desc = departmentLookup.find(x => x.pmaId == park.attributes.PMA)
    const desc = map.get(String(park.attributes.PMA))
    park.desc = (desc) ? desc : ''
    //console.log("mapping test" + park.desc)
  }



  //remove parks with no description
  
  parks = parks.filter(function(item) {
    return item.desc !== '' 
  })

  // ✅ SORT BY NAME (A → Z)
  parks.sort((a, b) =>
    a.attributes.NAME.localeCompare(b.attributes.NAME)
  );

  //get all amenities from arcgis
  let amenities = [] 
  for(const [key] of Object.entries(parks[0].attributes)){
    if(key !== 'NAME' 
    && key !== 'PMA' 
    && key !== 'SE_ANNO_CAD_DATA'
    && key !== 'PARKS_AREA' 
    && key !== 'Park_URL' 
    && key !== 'Address' 
    && key !== 'PMA_Name'
    ){
      amenities.push(key.replaceAll("_", " ").replace(/([a-z])([A-Z])/g, '$1 $2'));
    }      
  }
  amenities.sort();

  return {parks:parks,
    filters:{amenities}
  };
}

const getParkDescription = async () => {
  try {
    const { data } = await axios.get(api)
    return data
  } catch (err) {
    console.log('DSS API failed: ', err) /* eslint-disable-line */
    try {
      const { data } = await axios.get(apiBackup)
      return data
    } catch (err) {
      console.log('Json backup failed')
      // console.log(err);
      return []
    }
  }
}


export default {
  getParklist,
}


